import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import RequireAuth from "@/components/RequireAuth";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Accounts from "@/pages/Accounts";
import JobWizard from "@/pages/JobWizard";
import JobDetail from "@/pages/JobDetail";
import Settings from "@/pages/Settings";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminJobs from "@/pages/admin/AdminJobs";
import AdminSystem from "@/pages/admin/AdminSystem";
import AdminPlans from "@/pages/admin/AdminPlans";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminLegal from "@/pages/admin/AdminLegal";
import AdminEmails from "@/pages/admin/AdminEmails";
import AdminAudit from "@/pages/admin/AdminAudit";
import Legal from "@/pages/Legal";
import Status from "@/pages/Status";
import Contact from "@/pages/Contact";
import AdminContact from "@/pages/admin/AdminContact";
import CookieConsent from "@/components/CookieConsent";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/status" element={<Status />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
            <Route
              path="/billing/success"
              element={
                <RequireAuth>
                  <BillingSuccess />
                </RequireAuth>
              }
            />
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/accounts"
              element={
                <RequireAuth>
                  <Accounts />
                </RequireAuth>
              }
            />
            <Route
              path="/jobs/new"
              element={
                <RequireAuth>
                  <JobWizard />
                </RequireAuth>
              }
            />
            <Route
              path="/jobs/:id/edit"
              element={
                <RequireAuth>
                  <JobWizard />
                </RequireAuth>
              }
            />
            <Route
              path="/jobs/:id"
              element={
                <RequireAuth>
                  <JobDetail />
                </RequireAuth>
              }
            />
            <Route
              path="/settings"
              element={
                <RequireAuth>
                  <Settings />
                </RequireAuth>
              }
            />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route index element={<AdminOverview />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="plans" element={<AdminPlans />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="emails" element={<AdminEmails />} />
              <Route path="contact" element={<AdminContact />} />
              <Route path="legal" element={<AdminLegal />} />
              <Route path="audit" element={<AdminAudit />} />
              <Route path="system" element={<AdminSystem />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" closeButton />
          <CookieConsent />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
